import { module } from './store'

const KEY = 'notification'

export const NotificationExtend = {
  key: KEY,
  store: { modules: [{ key: KEY, module }] }
}
